import { useCallback, useRef } from "react";
import { useOrderFormState } from "@boundary/_hooks/useOrderFormState";
import { debounce } from "@shared/utils/debounce";

export function useDebouncedPriceCalculation(vm: ReturnType<typeof useOrderFormState>) {
  // Создаем debounced функцию один раз для каждого экземпляра хука
  const debouncedCalculateRef = useRef(
    debounce(() => {
      void vm.calculatePrice();
    }, 100) // 100ms для почти мгновенной реакции
  );

  return useCallback(() => {
    debouncedCalculateRef.current();
  }, []);
}

